<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$dark:      #1a1a2e;
$gray:      #6c7280;
$font:      'Segoe UI', system-ui, sans-serif;

.disc-wrap {
  background: $teal-bg !important;
  min-height: 100vh;
  font-family: $font;
}

.disc-page-container {
  padding-top: 24px;
  padding-bottom: 90px;

  @media (min-width: 768px)  { padding-top: 32px; }
  @media (min-width: 1024px) { padding-top: 40px; max-width: 860px; margin: 0 auto; }
}

.disc-heading {
  margin-bottom: 20px;

  &__title {
    font-size: 20px;
    font-weight: 700;
    color: $teal-dark;
    margin: 0 0 6px;

    @media (min-width: 768px) { font-size: 24px; }
  }

  &__sub {
    font-size: 13px;
    color: $gray;
    margin: 0;
  }
}

.disc-card {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid rgba(91, 184, 177, 0.2);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  font-family: $font;

  &__body {
    padding: 20px;
    max-height: 55vh;
    overflow-y: auto;
    font-size: 14px;
    color: $dark;
    line-height: 1.7;

    @media (min-width: 768px) { padding: 28px; font-size: 15px; }

    p, li { color: $dark; margin-bottom: 10px; }
    h1, h2, h3, h4 { color: $teal-dark; margin-bottom: 10px; }
    strong { color: $dark; }

    &::-webkit-scrollbar       { width: 5px; }
    &::-webkit-scrollbar-track { background: #f0f9f8; border-radius: 4px; }
    &::-webkit-scrollbar-thumb { background: $teal; border-radius: 4px; }
  }
}

.disc-accept {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid rgba(91, 184, 177, 0.18);
  background: rgba(91, 184, 177, 0.03);

  @media (min-width: 768px) { padding: 18px 28px; }

  &__checkbox {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: $teal;
  }

  &__label {
    font-size: 14px;
    font-weight: 600;
    color: $dark;
    cursor: pointer;
    margin: 0;
    user-select: none;
  }
}
</style>

<template>
  <section class="disc-wrap content d-flex flex-column flex-column-fluid">
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid disc-page-container">

        <div class="disc-heading">
          <h2 class="disc-heading__title">Biometric Data Collection Disclosure</h2>
          <p class="disc-heading__sub">Please read and accept the following disclosure before continuing.</p>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="disc-card">
              <div
                class="disc-card__body"
                v-html="getSettingNote.biometric_data_collection_disclosure_note"
              ></div>
              <div class="disc-accept">
                <input
                  type="checkbox"
                  class="disc-accept__checkbox"
                  v-model="check1"
                  id="bio-check-accept"
                />
                <label for="bio-check-accept" class="disc-accept__label">
                  I accept these terms and conditions.
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <v-foooter
        v-on:next="nextStep"
        v-on:back="back"
        :btnname="'Next'"
        :backname="'Back'"
      ></v-foooter>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import vFoooter from "./citizen/foooter.vue";
export default {
  data() {
    return {
      check1: false,
    };
  },
  components: {
    vFoooter,
  },
  computed: {
    ...mapGetters(["getSettingNote", "getfServiceSlug", "getServiceType", "getAttorneyRequest"]),
  },
  methods: {
    back() {
      if (this.getAttorneyRequest) {
        this.$router.push({
          name: "client.appointment.request-letter",
          params: { id: this.$route.params.id, client_slug: this.$route.params.client_slug },
        });
      } else {
        this.$router.push({
          name: "frontend.agent.locations",
          params: { slug: this.getfServiceSlug },
        });
      }
    },
    nextStep() {
      if (!this.check1) {
        this.$toastr.e("Please accept the terms and conditions");
        return;
      }
      var client_slug = this.$route.params.client_slug;
      var id = this.$route.params.id;

      if (this.getServiceType == "citizen") {
        this.$router.push({ name: "client.appointment.citizenship", params: { id, client_slug } });
      } else if (this.getServiceType == "DISCLOSURE") {
        this.$router.push({ name: "client.appointment.disclosure", params: { id, client_slug } });
      } else if (this.getServiceType == "none") {
        this.$router.push({ name: "frontend.booknow", params: { id, client_slug } });
      }
    },
  },
};
</script>
